import React from 'react';
import { MdCheck, MdFileCopy } from "react-icons/md";

const ShortTruncateCopy = ({
  info,
  slice = 50,
  showCopy,
}: {
  info: string;
  slice?: number;
  showCopy?: boolean;
}) => {
  const [copy, setCopy] = React.useState(false);

  const truncatedText =
    info?.length > slice ? info.substring(0, slice) + "..." : info;

  return (
    <div className="stc-wrap">
      <span className="stc-text">{truncatedText}</span>

      {showCopy && (
        copy ? (
          <MdCheck className="stc-icon stc-icon--done" />
        ) : (
          <MdFileCopy
            className="stc-icon"
            onClick={() => {
              navigator.clipboard.writeText(info);
              setCopy(true);
              setTimeout(() => setCopy(false), 1500);
            }}
          />
        )
      )}

      <style>{`
        .stc-wrap {
          display: flex;
          align-items: center;
          gap: 6px;
          min-width: 0;        /* allow shrinking inside any flex parent */
          max-width: 100%;
        }
        .stc-text {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          min-width: 0;
          flex: 1 1 0%;        /* grow + shrink from 0 base */
        }
        .stc-icon {
          flex-shrink: 0;      /* icon never squishes */
          cursor: pointer;
          color: #14b8a6;
          font-size: 15px;
        }
        .stc-icon--done {
          cursor: not-allowed;
          color: #14b8a6;
        }

        /* On narrow screens reduce font slightly */
        @media (max-width: 480px) {
          .stc-text { font-size: 12px; }
          .stc-icon { font-size: 14px; }
        }
      `}</style>
    </div>
  );
};

export default ShortTruncateCopy;